import { NgModule } from '@angular/core';
import { ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import { SummaryComponent } from './summary.component';

@NgModule({
  declarations: [SummaryComponent],
  imports: [ButtonModule],
  exports: [SummaryComponent]
})
export class SummaryModule {}
